import ServiceExec from '@/common/utils/ServiceExec';
import { wellDying } from '@/common/service/apiList';
import store from '@/store';
import { cloneDeep } from 'lodash';
import { asFormData } from '@/common/utils/module/FormDataSupport';
import { REMOVE_EMPTY_PARAMS } from '@/common/utils/module/FormattingSupport';
import ConstCode, { WELL_DYING_CODE } from '@/common/constants/ConstCode';

const wellDyingPrefix = '/api/wellDying';

export default {
  issueCookie: async function({ state, commit, getters }) {
    await ServiceExec.post(`/api/media/cookie`);
  },
  getList: async function({ state, commit, getters }, category) {
    const condition = getters['getCondition'];

    if (condition.page > state.pageInfo.totalPage) return false;
    const { userNo } = store.getters['user/getUserData'];

    // 응답 정보로 userNo가 넘어올경우 = 우리가족 히스토리에서 접근할 경우
    // if (payload.userNo) condition.userNo = payload.userNo;
    // else condition.userNo = userNo;

    const payload = {
      ...condition,
      category: category,
      userNo: userNo
    };

    // let userData = store.getters['user/getUserData'];
    // if (condition.category === 'FAMILY_ROOM') condition.familyCode = userData.familyCode;

    const { data, status } = await ServiceExec.get(wellDying.getList, REMOVE_EMPTY_PARAMS(payload));

    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;

    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
    return true;
  },

  getMyList: async function({ state, commit, getters }, category) {
    const condition = getters['getCondition'];

    if (condition.page > state.pageInfo.totalPage) return false;
    const { userNo } = store.getters['user/getUserData'];

    const param = {
      ...condition,
      category: category,
      userNo: userNo
    };

    // let userData = store.getters['user/getUserData'];
    // if (condition.category === 'FAMILY_ROOM') condition.familyCode = userData.familyCode;

    const { data, status } = await ServiceExec.get(wellDying.getMyList, REMOVE_EMPTY_PARAMS(param));

    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;

    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
    return true;
  },

  async getDetail({ commit, getters, state }, payload) {
    const userData = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(
      wellDying.getDetail(payload.category, payload.wellNo, userData?.userNo)
    );
    if (ServiceExec.status.OK !== status) return;

    if (payload.category !== WELL_DYING_CODE.WELL_PRAY.key) {
      // 중보기도 아닌 경우 file signed url 발급
      if (data.files && data.files.length > 0) {
        const fileNos = data.files.map(item => item.fileNo);
        const files = await ServiceExec.post(`/api/media/signed-url`, { fileNos });
        data.files = files?.data;
      }
    }

    commit('setDetail', data ?? '');
  },

  async deleteWellDying({ commit, getters, state }, payload) {
    const { status } = await ServiceExec.patch(wellDying.deleteWellDying + payload.category + '/' + payload.wellNo);
    if (ServiceExec.status.OK !== status) return false;

    const list = getters['getList'];
    const index = list.findIndex(item => Number(item.wellNo) === Number(payload.wellNo));
    let newList = list.filter((item, idx) => idx !== index);

    if (index > -1) commit('setNewList', newList);
    return true;
  },

  /**
   * 웰다잉 신규 등록
   * @param payload
   * @returns {Promise<*>}
   */
  async addWellDying({ commit, getters, state }, payload) {
    const userData = store.getters['user/getUserData'];

    const reqData = cloneDeep({ ...payload, userNo: userData.userNo });
    // if (userData.familyCode) reqData.familyCode = userData.familyCode;

    // 빈 문자열로 초기화된 파일 필드(firstImageFileInfo 등)를 제거 — 안 그러면 Spring이
    // ''(String)을 FileDto/MultipartFile로 바인딩하려다 BindException → 저장 실패 (안데르센과 동일 패턴)
    const formData = asFormData(REMOVE_EMPTY_PARAMS(reqData));
    const response = await ServiceExec.multiPost(wellDying.addWellDying, formData);
    if (ServiceExec.status.OK !== response?.status) return response?.data;

    commit('initPage');
    return response?.data;
  },

  async updateWellDying({ commit, getters, state }, payload) {
    const userData = store.getters['user/getUserData'];
    const reqData = cloneDeep({ ...payload, userNo: userData.userNo });
    // if (userData.familyCode) reqData.familyCode = userData.familyCode;

    const formData = asFormData(REMOVE_EMPTY_PARAMS(reqData));
    const response = await ServiceExec.multiPut(wellDying.updateWellDying, formData);
    if (ServiceExec.status.OK !== response?.status) return false;

    store.commit('welldying/initPage');
    return response?.data;
  },

  async view({ commit, getters, state }, payload) {
    const userData = store.getters['user/getUserData'];
    if (!userData || !userData.userNo) return;
    // if (payload?.userNo == userData?.userNo) return;

    await ServiceExec.patch(wellDyingPrefix + '/view/' + payload.wellNo);
  },

  async like({ commit, getters, state }) {
    const userData = store.getters['user/getUserData'];
    if (!userData || !userData.userNo) return;

    let wellDying = cloneDeep(getters['getDetail']);

    const wellNo = wellDying.wellNo;

    const { status, data } = await ServiceExec.post(wellDyingPrefix + `/like/${wellNo}/${userData.userNo}`);
    if (ServiceExec.status.OK !== status) return false;

    wellDying.isLike = !wellDying.isLike;
    commit('setDetail', wellDying);
    return true;
  },

  async getLikePrayList({ commit, getters, state }) {
    const condition = getters['getCondition'];

    if (condition.page > state.pageInfo.totalPage) return false;
    const { userNo } = store.getters['user/getUserData'];

    const payload = {
      ...condition,
      userNo: userNo
    };

    const { data, status } = await ServiceExec.get(wellDyingPrefix + '/like/pray', REMOVE_EMPTY_PARAMS(payload));

    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;

    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setList', list ?? []);
    return true;
  }
};
